import useSWR from "swr";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";

/**
 *
 * @returns {import("swr").SWRResponse<
 *   { [key: string]: string },
 *   {},
 *   unknown,
 * >}
 */

export function useCountries() {
  const axiosClient = useAxiosWithAuth();

  return useSWR("countries", async (url) => {
    const { data } = await axiosClient.wrap(axiosClient.get(url));
    return data;
  });
}
